import { languages } from '@/app/[lang]/dictionaries';

export const locales = ['en', 'es', 'zh', 'ru', 'hi', 'ar', 'fr', 'pt'];

export const i18nConfig = {
  defaultLocale: 'en',
  locales,
} as const;

export type Locale = (typeof i18nConfig)['locales'][number];

export type Lang = (typeof locales)[number];

export const LANGS: Array<Lang> = locales;

export const otherLang = (lang: Lang) => (lang === 'en' ? 'ru' : 'en');

const langs: Array<Lang> = i18nConfig.locales as unknown as Array<Lang>;

export type Dict = {
  [key: string]: string | Dict;
};

export const getOtherLanguages = (lang: Lang) => {
  return langs.filter((_lang) => _lang != lang);
};

export const getCurrentLanguage = (lang: Lang) => {
  return languages.find((_lang) => _lang.link === lang);
};

function getFromDictionnary(keys: Array<string>, dict: Dict | string): Dict | string {
  if (typeof dict == 'string') {
    return dict;
  }

  if (keys.length === 0) {
    return '';
  }

  if (!dict) {
    return '';
  }

  const key = keys.shift() || '';

  return getFromDictionnary(keys, dict[key]);
}

export const _t = (
  key: string,
  dict: Dict,
  options?: { [key: string]: number | string }
): string => {
  if (!key) {
    return '';
  }

  const keys = (key || '').split('.');

  let ret = getFromDictionnary(keys, dict);
  if (!ret) {
    return key;
  }

  if (typeof ret !== 'string') {
    console.error('getFromDict returned a ' + typeof ret);
    return key;
  }

  for (let key in options) {
    if (ret.includes(`{{${key}}}`)) {
      ret = ret.replaceAll(`{{${key}}}`, options[key] as string);
    }
  }

  return ret;
};
